module.exports = ":host {\n  width: 100%;\n  padding-top: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/dashboard/recent-leads-block/recent-leads-block.scss
// module id = ./web/modern/components/dashboard/recent-leads-block/recent-leads-block.scss
// module chunks = 0